import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "72",
  height: "72",
  viewBox: "0 0 72 72",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("title", null, "icon-ui-option-bookmark", -1),
    _createElementVNode("path", {
      d: "M55 5H17v57l19-14.25L55 62V5zM12 0h48v72L36 54 12 72V0z",
      "fill-rule": "nonzero"
    }, null, -1)
  ]))]))
}
export default { render: render }